import { objectBoolToArrayString } from "~/common/helpers/object-bool-to-array-string";
import { GetAllOrdersDto } from "~/common/interfaces/dto/orders/get-all-orders.dto";
import type { Filter } from "~/common/interfaces/filter.interface";

export const serializeOrderFilters = (updatedFilters: Filter[]) => {
	const serializedFilters: GetAllOrdersDto = {};
	updatedFilters.forEach((filter) => {
		const value = filter.value as Record<string, boolean>;

		if (filter.name === "Status") {
			serializedFilters.statuses = objectBoolToArrayString(value as Record<string, boolean>);
		}
	});

	return serializedFilters;
};
